import {store} from "../app/store";
import {logoutAction} from "../features/login/loginSlice";
import {getAuth, signOut} from "firebase/auth";
import {app} from "../firebaseConfig";


const auth = getAuth(app);

const status401Interceptor =  async (err: any) => {

    if(err.response && err.response.status === 401){
        console.log('processo di logout');
        // const originalRequest = err.config;
        // if (err.response.status === 401 && !originalRequest._retry) {
        //     originalRequest._retry = true;
        //     console.log(originalRequest);
        //     const auth = getAuth(app);
        //     const access_token = await auth.currentUser?.getIdToken(true);
        //     httpData.other.token = access_token;
        //     // originalRequest.headers['Authorization'] = 'Bearer ' + access_token;
        //     // console.log(originalRequest)
        //     return axios(originalRequest);
        // }
        signOut(auth).then(res => {
            store.dispatch(logoutAction())
        })

        return Promise.reject(err);
    }
    return Promise.reject(err);
}

export default status401Interceptor;
